export const input2Duration = timeObj => ((parseInt(timeObj.Day, 10) * 24 * 60) + (parseInt(timeObj.Hour, 10) * 60) + parseInt(timeObj.Min, 10));

export const duration2Input = (timeInMin) => {
  const timeObj = { Min: 0, Hour: 0, Day: 0 };
  timeObj.Min = (timeInMin % 60) || 0;
  const remainingHours = parseInt(timeInMin / 60, 10) || 0;
  timeObj.Hour = remainingHours % 24;
  timeObj.Day = parseInt(remainingHours / 24, 10) || 0;

  return timeObj;
};

export const findOptionbyKey = (options, searchKey, optionKey = 'key') => {
  const foundKeys = options.filter(option => option[optionKey] === searchKey);
  if (foundKeys && foundKeys.length > 0) {
    return foundKeys[0];
  }
  return {};
};

export const allSettledPromiseWrapper = (promises) => {
  const wrappedPromises = promises.map(p => Promise.resolve(p)
    .then(
      val => ({ status: 'fulfilled', value: val }),
      err => ({ status: 'rejected', reason: err })
    ));
  return Promise.all(wrappedPromises);
};
